var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.705078,
    y: 0.784668,
    width: 26.8317,
    height: 26,
    rx: 6,
    fill: "#EDF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61328 13.7847C6.61328 14.4374 7.1424 14.9666 7.7951 14.9666H19.6133C20.266 14.9666 20.7951 14.4374 20.7951 13.7847C20.7951 13.132 20.266 12.6029 19.6133 12.6029H7.7951C7.1424 12.6029 6.61328 13.132 6.61328 13.7847Z",
    fill: "#234596"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyOCAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43MDUwNzgiIHk9IjAuNzg0NjY4IiB3aWR0aD0iMjYuODMxNyIgaGVpZ2h0PSIyNiIgcng9IjYiIGZpbGw9IiNFREYwRjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjYxMzI4IDEzLjc4NDdDNi42MTMyOCAxNC40Mzc0IDcuMTQyNCAxNC45NjY2IDcuNzk1MSAxNC45NjY2SDE5LjYxMzNDMjAuMjY2IDE0Ljk2NjYgMjAuNzk1MSAxNC40Mzc0IDIwLjc5NTEgMTMuNzg0N0MyMC43OTUxIDEzLjEzMiAyMC4yNjYgMTIuNjAyOSAxOS42MTMzIDEyLjYwMjlINy43OTUxQzcuMTQyNCAxMi42MDI5IDYuNjEzMjggMTMuMTMyIDYuNjEzMjggMTMuNzg0N1oiIGZpbGw9IiMyMzQ1OTYiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };